import { render } from "./PageBeingConstructed.vue?vue&type=template&id=49c6f3e0&scoped=true"
import script from "./PageBeingConstructed.vue?vue&type=script&lang=js"
export * from "./PageBeingConstructed.vue?vue&type=script&lang=js"

import "./PageBeingConstructed.vue?vue&type=style&index=0&id=49c6f3e0&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c6f3e0"]])

export default __exports__